import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  headers: {
    'content-type': 'application/json',
  },
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000, // request timeout process.env.VUE_APP_BASE_API
})
service.interceptors.request.use(
  (config) => {
    // 从本地存储获取token
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res.code !== 200) {
      // token过期
      if (res.code == 401) {
        removeToken()
        store.commit('removeUserInfo')
        router.push('/login')
      }
      // this.$message.error(res.message);
      return res
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)
export default service
